import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";
import { ROUTE_LOGIN } from "../routes";
import { RootState } from "../store/rootReducer";

interface AuthenticatedRouteProps extends RouteProps {}

const AuthenticatedRoute = ({ children, ...rest }: AuthenticatedRouteProps) => {
  const location = useLocation();
  const authToken = useSelector(({ user: { authToken } }: RootState) => {
    return authToken;
  }, shallowEqual);

  if (!authToken) {
    return (
      <Redirect to={{ pathname: ROUTE_LOGIN, state: { from: location } }} />
    );
  }

  return <Route {...rest} children={children} />;
};

export default AuthenticatedRoute;
